import Handlebars from 'handlebars';

export default Handlebars.compile(`
<li class='event-card' data-id={{id}}>
  <button class='btn-delete-event' data-event-delete data-id={{id}}></button>
  <div class='event-frame'></div>
  <a href='{{url}}' target='_blank'><img class='card-image' src={{images.2.url}} alt={{name}} data-id={{id}} /></a>
  <div class='align'>
    <a href='{{url}}' target='_blank'><p class='card-title'data-id={{id}}>{{name}}</p></a>
    <p class='event-date'>{{dates.start.localDate}}</p>
    {{#if _embedded.venues.0.name}}
      <a class='event-location' target='_blank' href='https://www.google.com/maps/search/?api=1&query={{_embedded.venues.0.location.latitude}},{{_embedded.venues.0.location.longitude}}&query_place_id={{_embedded.venues.0.id}}'>
        <i class='material-icons button__icon'> room </i>
        {{_embedded.venues.0.name}}</a>
    {{else}}
      <a class='event-location' target='_blank' href='https://www.google.com/maps/search/?api=1&query={{_embedded.venues.0.location.latitude}},{{_embedded.venues.0.location.longitude}}&query_place_id={{_embedded.venues.0.id}}'>{{name}}</a>
    {{/if}}
  </div>
</li>
`);
